import { SATOSPortal } from "@/data-adapter/SATOSPortal";
import { useQuery } from "@tanstack/react-query";

import { OrganizationModules } from "@/model/Modules/OrganizationModules";

import { useFetchActiveUser } from "@/service/ApplicationQueries";

export const useFetchOrganizationModules = () => {
	const { data: user } = useFetchActiveUser();

	const companyId = user?.CompanyId;

	return useQuery<OrganizationModules>({
		queryKey: [ModulesQueryKeys.organizationModules, companyId],
		queryFn: () => SATOSPortal.OrganizationModules(companyId!),
		enabled: !!companyId,
	});
};

export class ModulesQueryKeys {
	static readonly organizationModules = "Organization Modules";
}
